// extracted by mini-css-extract-plugin
module.exports = {"readMore":"style_readMore__3puK4"};